import React, { useState, useEffect } from "react";
import Background from "../../assets/background_2.png";
import Card from "./Card";
import News from "./news";
import AluminaiRegistration from "./aluminai_registration";
import AlumniGallery from "./alumniGallery";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAluminaiData,
  fetchDirrectoryData,
} from "../../redux/slicer/aluminaiSlicer";
import Preloader from "../../assets/sab.jpeg"; // Preloader image
import AlumniImg from "../../assets/Banners/Alumni.jpg";
import OurMissionImg from "../../assets/Our Mission.JPG";
import OurVisionImg from "../../assets/Our Vision2.JPG";
import { fetchHistoryData } from "../../redux/slicer/aboutUsSlicer";
import parse from "html-react-parser";

function Aluminai() {
  const dispatch = useDispatch();
  const {
    data: aluminaiData,
    loading,
    error,
  } = useSelector((state) => state.aluminai.aluminai);

  const {
    data: dirrectoryData,
    dirrectoryLoading,
    dirrectoryError,
  } = useSelector((state) => state.aluminai.dirrectory);

  const [isExpandedVision, setIsExpandedVision] = useState(false);
  const [isExpandedMission, setIsExpandedMission] = useState(false);
  const [isExpandedGoal, setIsExpandedGoal] = useState(false);

  const [isOpenEdit, setIsOpenEdit] = useState(false); // Manage the popup state
  const [selectedCard, setSelectedCard] = useState(null); // Selected card state

  const [currentPage, setCurrentPage] = useState(1); // Current page
  const itemsPerPage = 5;

  const wordLimit = 150;

  useEffect(() => {
    dispatch(fetchAluminaiData());
    dispatch(fetchHistoryData());
    dispatch(
      fetchDirrectoryData({ page: currentPage, page_size: itemsPerPage })
    ); // Fetch data with pagination
  }, [dispatch, currentPage]);

  const openEditPopup = () => {
    setIsOpenEdit(true); // Open the popup when "Join With Us" is clicked
  };

  const closeEditPopup = () => {
    setIsOpenEdit(false); // Close the popup when the close button is clicked
  };

  // Function to truncate the description to the word limit
  const truncateDescription = (text, limit) => {
    if (!text) {
      return ""; // Return empty string if text is null or undefined
    }
    const words = text.split(" ");
    if (words.length > limit) {
      return words.slice(0, limit).join(" ") + "..."; // Truncate and add ellipsis
    }
    return text; // Return original text if within limit
  };

  // Function to handle page changes
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <img
          src={Preloader}
          alt="Loading..."
          className="w-24 h-24 sm:w-32 sm:h-32"
        />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <p className="text-red-600 text-lg font-bold">Error: {error}</p>
      </div>
    );
  }

  // Function to generate page numbers for pagination
  const generatePageNumbers = () => {
    const { total_pages } = dirrectoryData?.pagination || { total_pages: 1 };
    const pageNumbers = [];
    for (let i = 1; i <= total_pages; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  // Add logging for debugging

  return (
    <div>
      <div className="relative max-w-full mx-auto">
        <div className="contain overflow-hidden w-full  h-[400px]">
          <img
            src={AlumniImg}
            alt="carousel-slide"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute top-1/3 left-1/2 transform -translate-x-1/2 text-center text-white">
            <h2 className="text-6xl font-bold mt-10 font-titillium">Alumni</h2>
            <p className="text-lg mt-10 bg-img-description">
 
            </p>
          </div>
        </div>
      </div>

      <div className="py-10">
        <div className="py-10">
          <div className="py-6 mt-5" id="history">
            <p className="text-5xl text-primary-color font-titillium"></p>
          </div>
          <div className="relative w-full">
            <div className="relative w-full ">
              <div className="max-w-4xl p-6 m-4 mx-auto bg-white rounded-lg shadow-md">
                {aluminaiData?.vision ? (
                  <div className="text-gray-700 font-inter">
                    {parse(aluminaiData?.vision)}
                  </div>
                ) : (
                  <p>No data available.</p>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* <div className="py-6 mt-5" id="vission&mission">
          <p className="text-5xl text-primary-color text-center sm:text-center font-titillium">
            Vision, Mission & Goal
          </p>
        </div> */}

        {/* <div className="relative w-full  sm:h-[600px] grid content-center">
          <div className="relative w-full  hidden sm:block">
            <img
              src={Background}
              alt="Background"
              className="w-full h-full object-cover"
            />
          </div>


          <div className="hidden sm:grid absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  px-5 max-w-full w-[1300px] z-5 grid-rows-2 grid-flow-col gap-6 ">

            <div className="bg-white rounded-lg shadow-lg overflow-hidden p-6 md:p-4 lg:p-4">

              <h3 className="text-2xl font-semibold text-primary-color mb-3 font-titillium text-center md:text-xl lg:text-xl">
      
                Our Vision
              </h3>
              <p className="text-gray-700 text-base leading-relaxed text-left md:text-sm lg:text-md">

                {aluminaiData?.vision
                  ? parse(
                      isExpandedVision
                        ? aluminaiData.vision
                        : truncateDescription(aluminaiData.vision, wordLimit)
                    )
                  : "Our Vision Description"}
                {aluminaiData?.vision &&
                  aluminaiData.vision.split(" ").length > wordLimit && (
                    <button
                      className="text-blue-500 hover:text-blue-700 focus:outline-none md:text-xs lg:text-lg"
                      onClick={() => setIsExpandedVision(!isExpandedVision)}
                    >
                      {isExpandedVision ? "Read Less" : "Read More"}
                    </button>
                  )}
              </p>
            </div>

   
            <div className="bg-white rounded-lg shadow-lg overflow-hidden p-6 md:p-4 lg:p-4">

              <h3 className="text-2xl font-semibold text-primary-color mb-3 font-titillium text-center md:text-xl lg:text-xl">
  
                Our Mission
              </h3>
              <p className="text-gray-700 text-base leading-relaxed text-left md:text-sm lg:text-md">
           
                {aluminaiData?.mission
                  ? parse(
                      isExpandedMission
                        ? aluminaiData.mission
                        : truncateDescription(aluminaiData.mission, wordLimit)
                    )
                  : "Our Mission Description"}
                {aluminaiData?.mission &&
                  aluminaiData.mission.split(" ").length > wordLimit && (
                    <button
                      className="text-blue-500 hover:text-blue-700 focus:outline-none md:text-xs lg:text-md"
                      onClick={() => setIsExpandedMission(!isExpandedMission)}
                    >
                      {isExpandedMission ? "Read Less" : "Read More"}
                    </button>
                  )}
              </p>
            </div>
   
            <div className="bg-white rounded-lg shadow-lg overflow-hidden p-6 row-start-2 col-start-1 col-span-2 md:p-4 lg:p-4">

              <h3 className="text-2xl font-semibold text-primary-color mb-3 font-titillium text-center md:text-xl lg:text-xl">
   
                Our Goal
              </h3>
              <p className="text-gray-700 text-base leading-relaxed text-left md:text-sm lg:text-md">

                {aluminaiData?.goals
                  ? parse(
                      isExpandedGoal
                        ? aluminaiData.goals
                        : truncateDescription(aluminaiData.goals, wordLimit)
                    )
                  : "Our Goal Description"}
                {aluminaiData?.goals &&
                  aluminaiData.goals.split(" ").length > wordLimit && (
                    <button
                      className="text-blue-500 hover:text-blue-700 focus:outline-none md:text-lg lg:text-lg"
                      onClick={() => setIsExpandedGoal(!isExpandedGoal)}
                    >
                      {isExpandedGoal ? "Read Less" : "Read More"}
                    </button>
                  )}
              </p>
            </div>
          </div>
        </div> */}

        {/* <div className="grid grid-cols-1 sm:hidden gap-4 px-4 py-6">
          <div className="bg-white rounded-lg shadow-lg overflow-hidden p-6">
            <h3 className="text-2xl font-semibold text-primary-color mb-3 font-titillium text-center">
              Our Vision
            </h3>
            <p className="text-gray-700 text-base leading-relaxed text-left">
              {aluminaiData?.vision
                ? parse(
                    isExpandedVision
                      ? aluminaiData.vision
                      : truncateDescription(aluminaiData.vision, wordLimit)
                  )
                : "Our Vision Description"}
              {aluminaiData?.vision &&
                aluminaiData.vision.split(" ").length > wordLimit && (
                  <button
                    className="text-blue-500 hover:text-blue-700 focus:outline-none"
                    onClick={() => setIsExpandedVision(!isExpandedVision)}
                  >
                    {isExpandedVision ? "Read Less" : "Read More"}
                  </button>
                )}
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-lg overflow-hidden p-6">
            <h3 className="text-2xl font-semibold text-primary-color mb-3 font-titillium text-center">
              Our Mission
            </h3>
            <p className="text-gray-700 text-base leading-relaxed text-left">
              {aluminaiData?.mission
                ? parse(
                    isExpandedMission
                      ? aluminaiData.mission
                      : truncateDescription(aluminaiData.mission, wordLimit)
                  )
                : "Our Mission Description"}
              {aluminaiData?.mission &&
                aluminaiData.mission.split(" ").length > wordLimit && (
                  <button
                    className="text-blue-500 hover:text-blue-700 focus:outline-none"
                    onClick={() => setIsExpandedMission(!isExpandedMission)}
                  >
                    {isExpandedMission ? "Read Less" : "Read More"}
                  </button>
                )}
            </p>
          </div>
          <div className="bg-white rounded-lg shadow-lg overflow-hidden p-6">
            <h3 className="text-2xl font-semibold text-primary-color mb-3 font-titillium text-center">
              Our Goal
            </h3>
            <p className="text-gray-700 text-base leading-relaxed text-left">
              {aluminaiData?.goals
                ? parse(
                    isExpandedGoal
                      ? aluminaiData.goals
                      : truncateDescription(aluminaiData.goals, wordLimit)
                  )
                : "Our Goal Description"}
              {aluminaiData?.goals &&
                aluminaiData.goals.split(" ").length > wordLimit && (
                  <button
                    className="text-blue-500 hover:text-blue-700 focus:outline-none"
                    onClick={() => setIsExpandedGoal(!isExpandedGoal)}
                  >
                    {isExpandedGoal ? "Read Less" : "Read More"}
                  </button>
                )}
            </p>
          </div>
        </div> */}

        <div className="grid grid-cols-1 md:grid-cols-12 px-4 md:px-8 lg:px-16 xl:px-24 mt-5">
          {/* Left Empty Space - Hidden on Small Screens */}
          <div className="hidden md:block md:col-span-2"></div>

          {/* Main Content */}
          <div className="col-span-12 md:col-span-8 mt-8">
            <div id="news">
              <h2 className="text-3xl sm:text-4xl text-primary-color font-titillium text-center md:text-left">
                Alumni Latest News
              </h2>
            </div>

            <div className="py-6">
              <News />
            </div>

            <div id="gallery">
              <h2 className="text-3xl sm:text-4xl text-primary-color font-titillium text-center md:text-left">
                Alumni Gallery
              </h2>
            </div>

            <div className="py-6">
              <AlumniGallery />
            </div>

            <div id="directory">
              <h2 className="text-3xl sm:text-4xl text-primary-color font-titillium text-center md:text-left">
                Alumni Directory
              </h2>
            </div>

            <button
              onClick={() => window.open("/alumni-directory", "_blank")}
              className="bg-primary-color text-lg sm:text-xl text-white rounded-full w-[80%] sm:w-[200px] h-[40px] mt-5 flex items-center justify-center mx-auto md:ml-6"
            >
              Access to Directory
            </button>
            {/* Registration Section */}
            <div className="py-6">
              <div id="registration">
                <h2 className="text-3xl sm:text-4xl text-primary-color mt-5 text-center md:text-left font-titillium">
                  Alumni Registration Process
                </h2>

                <div className="bg-primary-color h-[1px] w-[80%] md:w-[300px] mx-auto md:ml-6 mt-5"></div>

                <button
                  onClick={openEditPopup}
                  className="bg-primary-color text-lg sm:text-xl text-white rounded-full w-[80%] sm:w-[200px] h-[40px] mt-5 flex items-center justify-center mx-auto md:ml-6"
                >
                  Join With Us
                </button>
              </div>
            </div>
          </div>

          {/* Right Empty Space - Hidden on Small Screens */}
          <div className="hidden md:block md:col-span-2"></div>
        </div>
      </div>

      {isOpenEdit && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
          <div className="bg-white  rounded-lg relative max-w-[1400px] w-full max-h-[80vh] overflow-y-auto">
            <AluminaiRegistration onClose={closeEditPopup} />
          </div>
        </div>
      )}
    </div>
  );
}

export default Aluminai;
